import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop() {
    const { pathname } = useLocation();

    const first = pathname.split('/')[1]

    // `product` keys off the full pathname so moving between two product pages
    // (same first segment) still scrolls to top.
    //
    // The create-listing wizard is excluded: it walks through
    // /product/create/:id -> /listings -> /classify -> /payment, and keying off
    // the full pathname re-fired scrollTo(0, 0) on every step, snapping the user
    // back to the top mid-form. One stable key for the whole flow instead.
    const isCreateFlow = first === 'product' && pathname.split('/')[2] === 'create'
    let key = isCreateFlow
        ? 'product/create'
        : first === 'product' ? pathname : first

    useEffect(() => {
        setTimeout(() => { // timeout is required to scroll after back button click
            window.scrollTo(0, 0);
        }, 0)
    }, [ key?.trim() || '_empty_' ]);

    return null;
}